import { z } from 'zod'

// form として実際には送信しないプロパティも含めている
export const RoomFormEntitySchema = z
  .object({
    id: z.string(),
    entityId: z.string().optional(),
    name: z.string(),
    floor: z.string(),
    priority: z.number(),
    // NOTE: 開発途中で optional → required に変更されたが、既に保存されていてロックされているものは undefined になるため、スキーマの定義としてはoptional にしている
    wingId: z.number().optional(),
    roomTypeId: z.number().optional(),
    isSelectEnabled: z.boolean(),
    memo: z.string().optional(),
    registrationDueDate: z.date().optional(),
    registrationStatus: z.enum(['waiting', 'registered', 'agreed']).optional(),
    isDeleted: z.boolean().optional(),

    // ソート時に利用する値
    nameForSorting: z.string(),
    floorForSorting: z.string(),
    wingIdForSorting: z.number().optional(),
    roomTypeIdForSorting: z.number().optional(),
    isSelectEnabledForSorting: z.boolean(),
    memoForSorting: z.string().optional(),
    registrationDueDateForSorting: z.date().optional(),

    selectMasters: z.array(
      z.object({
        id: z.number(),
        selectOptionMasterIds: z.array(z.number()),
        isDeleted: z.boolean().optional(),
        // リモートに保存されたことがある場合true
        hasBeenSaved: z.boolean().optional(),

        // ソート時に利用する値
        // NOTE:
        //  新たに住戸に設問を紐づけた場合、そもそも該当するidのオブジェクト自体がない。
        //  ソートを行う際の値は変更前の値が入るので、以前は住戸が紐づいていなかったような状態を作る際は undefined を入れる
        idForSorting: z.number().optional(),
      })
    ),
    contractor: z
      .object({
        id: z.number(),
        name: z.string(),
        email: z.string(),
        isConfirmed: z.boolean(),
        selectEmailSentTime: z.number(),
        agreementRequestEmailSentTime: z.number(),
      })
      .optional(),
    // TODO: ApplicationStatus から推察出来るようにする
    publishApplicationRequestStatus: z
      .enum(['waiting', 'reviewing', 'approved', 'rejected', 'canceled', 'approvalCanceled'])
      .optional(),
    orderApplicationRequestStatus: z
      .enum(['waiting', 'reviewing', 'approved', 'rejected', 'canceled', 'approvalCanceled'])
      .optional(),

    isLocked: z.boolean().optional(),
    isEnableProxySelectRegistration: z.boolean().optional(),

    isFiltered: z.boolean(),
  })
  // NOTE:
  //   ロックがかかっていない住戸には必要な値が入力されているを確認する
  //   リリース後には起こり得ないはずだが、STG等の既存データでロックがかかったものは編集が出来ず、以下バリデーションチェックに引っかかっても修正が出来ないため

  // 削除されていない&ロックがかかっていない住戸には住戸番号に正しい値が入力されているを確認する
  .refine(
    data => {
      if (!data.isDeleted && !data.isLocked) {
        return /^[ !-~]+$/.test(data.name)
      }
      return true
    },
    { message: '半角英数字で入力して下さい', path: ['name'] }
  )

  // 削除されていない&ロックがかかっていない住戸には棟に正しい値が入力されているを確認する
  .refine(
    data => {
      if (!data.isDeleted && !data.isLocked) {
        return /^[ !-~]+$/.test(data.floor)
      }
      return true
    },
    { message: '半角英数字で入力して下さい', path: ['floor'] }
  )

  // 削除されていない&ロックがかかっていない住戸には棟が選択されているを確認する
  .refine(
    data => {
      if (!data.isDeleted && !data.isLocked) {
        return data?.wingId !== undefined
      }
      return true
    },
    { message: '選択して下さい', path: ['wingId'] }
  )

  // 削除されていない&ロックがかかっていない住戸にはルームタイプが選択されているを確認する
  .refine(
    data => {
      if (!data.isDeleted && !data.isLocked) {
        return data?.roomTypeId !== undefined
      }
      return true
    },
    { message: '選択して下さい', path: ['roomTypeId'] }
  )

export const BulkUpdateRoomsFormEntitySchema = z.object({
  items: z.array(RoomFormEntitySchema),
})
export type WriteRoomFormEntity = z.infer<typeof RoomFormEntitySchema>
export type BulkUpdateRoomsFormEntity = z.infer<typeof BulkUpdateRoomsFormEntitySchema>
